import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Story } from '@core/models/story-manager/story';
import { styled } from '@naan/stitches.config';
import { learnStoryPath } from 'components/nav/path-helpers';
import { StoryTitle } from 'components/stories/story-title';
import { MarkSimple } from '@naan/primitives/text';

const Wrapper = styled(Link, {
  all: 'unset',
  cursor: 'pointer',
  '& > .thumbnail-image': {
    width: '100%',
    borderRadius: 8,
    marginBottom: 12,
  },
  '& > .title': {
    display: 'block',
    textStyle: 'small-heading',
    marginBottom: 4,
  },
  '& > .tagline': {
    display: 'block',
    color: '$textSecondary',
    textStyle: 'small-text',
  },
});

export const StoryMinicard = observer(({ story }: { story: Story }) => {
  return (
    <Wrapper to={learnStoryPath(story)} title={story.title}>
      <img
        src={story.listImageUrl}
        alt={story.title}
        className="thumbnail-image"
        crossOrigin="anonymous"
        style={{ backgroundColor: story.themeColor }}
      />
      <StoryTitle story={story} />
      <span className="tagline">
        <MarkSimple source={story.tagline} />
      </span>
    </Wrapper>
  );
});
